// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.InvoiceItemResponse */
/* istanbul ignore next */
@GandalfModel
export class InvoiceItemResponse extends GandalfModelBase {

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	adjustmentTotal!: number;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	amountPaid!: number;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	balance!: number;

	@GandalfProperty({ designType: String })
	code!: string;

	@GandalfProperty({ designType: String })
	description!: string;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	discountTotal!: number;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	extendedPrice!: number;

	@GandalfProperty({ designType: Number })
	id!: number;

	@GandalfProperty({ designType: Number })
	quantity!: number;

	@GandalfProperty({ designType: Number })
	responsiblePersonId!: number | null;

	@GandalfProperty({ designType: Boolean })
	split!: boolean | null;

	@GandalfConstantDecorator(constants.InvoiceItemStatus)
	@GandalfProperty({ designType: constants.InvoiceItemStatus })
	status!: constants.InvoiceItemStatus;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	taxAmount!: number;

	@GandalfProperty({ designType: Number })
	taxAppliedId!: number | null;

	@GandalfProperty({ designType: Number })
	taxRate!: number;

	@GandalfConstantDecorator(constants.InvoiceItemType)
	@GandalfProperty({ designType: constants.InvoiceItemType })
	type!: constants.InvoiceItemType;

	@GandalfProperty({ propertyType: 'Money', designType: Number })
	unitPrice!: number;

	@GandalfProperty({ designType: Boolean })
	wasSplit!: boolean | null;

}
